import { Partial } from '../../../common/src';
import { ErpSync } from './erp-sync.entity';

export class UpdateErpSyncDto extends Partial(ErpSync) {}
